<template>
  <div class="PageContentWrapper">
    <div class="ViewContainer">
      <div class="MentorsList">
        <div class="GridEvents">
          <router-link to="/org/notifications" style="text-decoration: none;">
            <div class="NotifCard">
              <span class="NCTitle">
                {{ $t("pages.profile.settings.title") }}
              </span>
              <span class="NCDesc">
                {{ $t("pages.profile.settings.desc") }}
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OneColumnTemplate from "@/components/ProfileTemplates/OneColumn.vue";
import DefaultModal from "@/components/DefaultModal";
import LUUIButtonPrimary from "@/components/LevelUpUI/Buttons/primary.vue";

import { QuillEditor } from "@vueup/vue-quill";
import { ElNotification } from "element-plus";

import { mapGetters, mapMutations } from "vuex";
import { findById } from "@/api/user.js";
import { refresh } from "@/api/auth.js";
import { RequestStatuses, RequestList, RequestUpdate } from "@/api/request.js";

export default {
  name: "RequestsList",

  components: {
    OneColumnTemplate,
    QuillEditor,
    LUUIButtonPrimary,
    DefaultModal,
  },

  data() {
    return {
      statuses: [],
      requests: [],

      statusesShow: false,
      statusesList: [],
    };
  },

  async created() {
    if (this.user == null) {
      this.updateUser();
    } else {
      this.getUser(this.user.id);
    }

    await this.initialization();
  },

  methods: {
    async initialization() {
      let respStatuses = await RequestStatuses();
      this.statuses = respStatuses?.data || [];

      let respRequests = await RequestList(this.user.parent_company?.[0]?.id);
      this.requests = respRequests?.data.reverse() || [];

      this.handleCloseModal();
    },

    ...mapMutations("auth", ["SET_USER"]),

    async updateUser() {
      const response = await refresh();
      const userResponse = response.user;
      this.getUser(userResponse.id);
    },

    getUser(id) {
      if (id != undefined) {
        findById(id).then((response) => {
          this.SET_USER(response.data);
        });
      }
    },

    async changeRequestStatus(requestID, newValue) {
      try {
        await RequestUpdate({
          requestID: requestID,
          statusID: newValue,
        });

        await this.initialization();

        ElNotification({
          title: "Успех!",
          message: "Статус заявки изменен",
          type: "success",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      } catch (e) {
        ElNotification({
          title: "Упс!",
          message: "Извините, произошла ошибка на сервере",
          type: "error",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      }
    },

    handleCloseModal() {
      this.statusesShow = false;
      this.statusesList = [];
    },
    handleHistories(request_histories) {
      this.statusesList = request_histories.map((x) => {
        let date = x.createdAt.split("T")[0];

        return {
          timestamp: date
            .split("-")
            .reverse()
            .join("."),
          content: x.request_status.name,
        };
      });

      this.statusesShow = true;
    },
  },

  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),
  },
};
</script>

<style scoped>
.PageContentWrapper {
  position: relative;
  display: flex;

  flex-direction: column;
  justify-content: flex-start;
  gap: 36px;

  width: 100%;

  height: 100%;

  padding-top: 15px;

  overflow: visible;
}

.ViewContainer {
  position: relative;

  margin: 0% auto;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;

  overflow: visible;
}

.Title {
  position: relative;
  display: block;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  font-family: "Open Sans";
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0px;

  color: #000000;
}

.MentorsList {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;
  flex-wrap: wrap;
}
.GridEvents {
  position: relative;
  display: grid;

  width: 100%;
  height: fit-content;

  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.NotifCard {
  position: relative;
  display: flex;

  padding: 24px;

  width: auto;

  min-height: 200px;
  height: auto;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;

  border-radius: 8px;

  border: 2px solid #f9d773;
}
.NCTitle {
  position: relative;
  display: inline;

  min-width: 0;
  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Montserrat";
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
  text-decoration: none;

  word-break: break-word;
  word-wrap: break-word;

  color: #000000;
}
.NCDesc {
  position: relative;
  display: inline;

  min-width: 0;
  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Montserrat";
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: left;
  text-decoration: none;

  word-break: break-word;
  word-wrap: break-word;

  color: #000000;
}

.MentorFIO {
  position: relative;
  display: inline;

  margin: auto 0%;

  min-width: 0;
  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Montserrat";
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: left;

  word-break: break-word;
  word-wrap: break-word;

  color: #000000;
}
.Mentor:hover {
  background-color: #27235c;
}
</style>
